import React, { useEffect } from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom'
import Header from './componets/Header';
import { useState } from 'react';
import Menu from './componets/Menu'
import HeaderPage from './componets/HomePage'
import Login from './LoginAccount/Login'
import { useDispatch, useSelector } from 'react-redux'; // this is a hook 
import { login, logout, selectUser } from './features/userSlice';
import SignUp from './signnup/SignUp'
import TeslaAccount from './TeslaAccount'
import { auth } from './firebase';



function App() {
  //hooks 
  const user = useSelector(selectUser)
  const [isMenuOpen, setIsMenuOpen] = useState(false) // we dont want the menu to open by default so we sit it to false
  const dispatch = useDispatch()


  // checks if the user is logged in or out 
 useEffect(() => {
//onAuthStateChanged checks the state if the user is loggeed in or out 
  auth.onAuthStateChanged((userAuth) => {
    if(userAuth){
      // USer is signed in 
      dispatch(login({
        email: userAuth.email,
        uid: userAuth.uid,
        displayName: userAuth.displayName
      })
      )
    }else{
      //User is Signed Out
      dispatch(logout())

    }
  })
   
 }, [dispatch])



  return (
    <Router>
      <div className="app">
        <switch>
          {/* routes are for paths */}
          <Route exact path='/'>
            {/* < Header />  */}
            {/* HeaderBlock  */}
            <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
            {/* only going to show the menu if its true   */}
            {isMenuOpen && <Menu />}
            {/* HomePage  or HomeBlock */}
            <HeaderPage />
            <HeaderPage />
            <HeaderPage />
          </Route>
          <Route exact path='/login'>
            {/* if the user loges in and the account is correct we wull redirect him to the teslaaccount */}
            {/* this is an if statemnt ':'  */}
            {/* ':' means if not, basically if not then we show the user the login page  */}
            {user ? <Redirect to='/teslaaccount' /> : <Login/>}
            <Login />
          </Route>
          <Route exact path='/signup'>
           
            <SignUp />
          </Route>
          <Route exact path='/teslaaccount'>
            {/*if the user is there we are going to redirect him to login */}
            {/*if the user is not there we are going to redirect him to create account*/}
            {/*if the user is  we wanna show the login so he lgoes in to the website */}
          {!user ? <Redirect to='/login' /> : (
            <>
            <TeslaAccount isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen}/>
            
            {isMenuOpen && <Menu />}
            </>
          ) }
            
          </Route>
        </switch>
      </div>
    </Router>
  );
}

export default App;
